import { useEffect, useRef } from "react";
import { io } from "socket.io-client";
import { envConfig } from "../utils/envConfig";
import { getAuthToken } from "../context/AuthActions";
import { useTransactionTrackingStore } from "../store/useTransactionTrackingStore";

export function useTransactionSocket(enabled = true) {
  const socketRef = useRef(null);
  const updateTransaction = useTransactionTrackingStore(
    (s) => s.updateTransaction
  );

  useEffect(() => {
    if (!enabled) return;

    const token = getAuthToken();
    if (!token) return;

    const socket = io(envConfig.baseUrl, {
      path: "/socket.io/",
      transports: ["websocket", "polling"],
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 30000,
      auth: { token },
    });

    socketRef.current = socket;

    socket.on("connect", () => {
      socket.emit("subscribe:transactions");
    });

    socket.on("transaction:update", (payload) => {
      if (payload?.data) {
        updateTransaction(payload.data);
      }
    });

    socket.on("transaction:new", (payload) => {
      if (payload?.data) {
        updateTransaction(payload.data);
      }
    });

    socket.on("transaction:catchup", (payload) => {
      if (payload?.data) {
        updateTransaction(payload.data);
      }
    });

    socket.on("connect_error", (err) => {
      console.warn("[TransactionSocket] Connection error:", err.message);
    });

    return () => {
      socket.emit("unsubscribe:transactions");
      socket.disconnect();
      socketRef.current = null;
    };
  }, [enabled, updateTransaction]);

  return socketRef;
}
